import {
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper
} from '@mui/material'
import React from 'react'

import { Risk } from 'components/support/risks/risk-form-utils'

const PAPER_WIDTH = 240
const PAPER_WIDTH_LARGE = 320
const PAPER_HEIGHT = 400

const responsivePaperStyle = (muiTheme) => ({
  [muiTheme.breakpoints.down('lg')]: {
    width: PAPER_WIDTH,
    height: PAPER_HEIGHT,
    overflow: 'auto',
    my: 2
  },
  [muiTheme.breakpoints.up('lg')]: {
    width: PAPER_WIDTH_LARGE,
    height: PAPER_HEIGHT,
    overflow: 'auto',
    my: 2
  }
})

export const TestSuiteRiskList: React.FC<{
  canEdit: boolean
  detectedRisks: Risk[]
  checked: Risk[]
  handleToggle: (risk: Risk) => () => void
}> = ({ canEdit, detectedRisks, checked, handleToggle }) => {
  return (
    <Paper sx={responsivePaperStyle}>
      <List component="div" data-testid="test-suite-risk-list" role="list">
        {detectedRisks.map((detectedRisk) => {
          const labelId = `transfer-list-item-${detectedRisk.id}-label`

          return canEdit ? (
            <ListItemButton
              key={detectedRisk.id}
              role="listitem"
              onClick={handleToggle(detectedRisk)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={
                    checked.findIndex((c) => c.id === detectedRisk.id) !== -1
                  }
                  inputProps={{
                    'aria-labelledby': labelId
                  }}
                  tabIndex={-1}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={detectedRisk.name} />
            </ListItemButton>
          ) : (
            <ListItem key={detectedRisk.id}>
              <ListItemText id={labelId} primary={detectedRisk.name} />
            </ListItem>
          )
        })}
      </List>
    </Paper>
  )
}
